import ItemPage from "./item-page";

export default ItemPage;